module.exports = __webpack_public_path__ + "static/silvanus-symbol-SCAG-9de32c53b521b294c3974483585c95e1.png";